import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { METHODS, SERVICES } from '../../api/constants';
import { makeRequest } from '../../api/api';
import CryptoJS from 'crypto-js';

export const fetchUserSubscriptionData = createAsyncThunk(
  'selfPacedSlice/fetchUserSubscriptionData',
  async (param, thunkApi) => {
    try {
      const hash = CryptoJS.HmacSHA256(
        JSON.stringify(param),
        '2d1e1v2e4s3h8zkkhehkod2d02fhjewjbd2whj4'
      ).toString(CryptoJS.enc.Hex);

      const response = await makeRequest(
        SERVICES.PAYMENTS_MIDDLEWARE_SERVICE,
        '/middleware/get-subscription-details',
        METHODS.POST,
        {},
        { ...param },
        [
          { key: 'access-key', value: 'sxb0zhsqm8yjpttc79iqlizxyd3e1a2' },
          { key: 'signature', value: hash }
        ]
      );

      return response?.data;
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  }
);

export const fetchPaymentLink = createAsyncThunk(
  'selfPacedSlice/fetchPaymentLink',
  async (param, thunkApi) => {
    try {
      const hash = CryptoJS.HmacSHA256(
        JSON.stringify(param),
        '2d1e1v2e4s3h8zkkhehkod2d02fhjewjbd2whj4'
      ).toString(CryptoJS.enc.Hex);

      const response = await makeRequest(
        SERVICES.PAYMENTS_MIDDLEWARE_SERVICE,
        '/middleware/generate-payment-link',
        METHODS.POST,
        {},
        { ...param },
        [
          { key: 'access-key', value: 'sxb0zhsqm8yjpttc79iqlizxyd3e1a2' },
          { key: 'signature', value: hash }
        ]
      );

      return response?.data;
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  }
);

export const fetchCouponDiscount = createAsyncThunk(
  'selfPacedSlice/fetchCouponDiscount',
  async (param, thunkApi) => {
    try {
      const hash = CryptoJS.HmacSHA256(
        JSON.stringify(param),
        '2d1e1v2e4s3h8zkkhehkod2d02fhjewjbd2whj4'
      ).toString(CryptoJS.enc.Hex);

      const response = await makeRequest(
        SERVICES.PAYMENTS_MIDDLEWARE_SERVICE,
        '/middleware/apply-coupon',
        METHODS.POST,
        {},
        { ...param },
        [
          { key: 'access-key', value: 'sxb0zhsqm8yjpttc79iqlizxyd3e1a2' },
          { key: 'signature', value: hash }
        ]
      );

      return response?.data;
    } catch (error) {
      return thunkApi.rejectWithValue(error);
    }
  }
);

export const fetchProgramType = createAsyncThunk(
  'selfPacedSlice/fetchProgramType',
  async (param, thunkApi) => {
    try {
      const hash = CryptoJS.HmacSHA256(
        JSON.stringify(param),
        '2d1e1v2e4s3h8zkkhehkod2d02fhjewjbd2whj4'
      ).toString(CryptoJS.enc.Hex);

      const response = await makeRequest(
        SERVICES.SPRINGBOOT_TO_NODE_APIS,
        '/self-paced/enrolled-data',
        METHODS.POST,
        {},
        { ...param },
        [
          { key: 'access-key', value: 'sxb0zhsqm8yjpttc79iqlizxyd3e1a2' },
          { key: 'signature', value: hash }
        ]
      );

      localStorage.setItem('userInput', JSON.stringify(param));
      localStorage.setItem('userResponse', JSON.stringify(response?.data));

      return response?.data;
    } catch (error) {
      localStorage.setItem('userInput', JSON.stringify(param));
      localStorage.setItem('userError', JSON.stringify(error));
      return thunkApi.rejectWithValue(error);
    }
  }
);

const selfPacedSlice = createSlice({
  name: 'selfPacedSlice',
  initialState: {
    useSubscriptionData: {},
    isUserSubscriptionLoading: false,
    isSubscriptionError: false,
    couponDetails: {},
    paymentLinkData: {},
    isPaymentLoading: false,
    isCouponDetailLoading: false,
    programData: {},
    loading: false,
    error: null,
    couponError: false
  },
  reducers: {
    clearLocalStorageOnLogout: (state) => {
      localStorage.removeItem('userInput');
    },
    setPaymentNull: (state, action) => {
      Object.keys(action.payload).map((val) => {
        state[val] = action.payload[val];
      });
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchProgramType.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProgramType.fulfilled, (state, action) => {
        state.loading = false;
        state.programData = action.payload;
      })
      .addCase(fetchProgramType.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchUserSubscriptionData.pending, (state) => {
        state.isUserSubscriptionLoading = true;
        state.isSubscriptionError = false;
        state.useSubscriptionData = {};
      })
      .addCase(fetchUserSubscriptionData.fulfilled, (state, action) => {
        state.isUserSubscriptionLoading = false;
        state.useSubscriptionData = action.payload;
        state.isSubscriptionError = false;
        if (!action.payload?.user_id) {
          state.isSubscriptionError = true;
        }
      })
      .addCase(fetchUserSubscriptionData.rejected, (state, action) => {
        state.isUserSubscriptionLoading = false;
        state.isSubscriptionError = true;
        state.useSubscriptionData = {};
      })
      .addCase(fetchCouponDiscount.pending, (state) => {
        state.isCouponDetailLoading = true;
        state.couponError = false;
        state.couponDetails = {};
      })
      .addCase(fetchCouponDiscount.fulfilled, (state, action) => {
        state.isCouponDetailLoading = false;
        state.couponDetails = action.payload;
        state.couponError = false;
      })
      .addCase(fetchCouponDiscount.rejected, (state, action) => {
        state.isCouponDetailLoading = false;
        state.couponError = true;
        set.couponDetails = {};
      })
      .addCase(fetchPaymentLink.pending, (state) => {
        state.isPaymentLoading = true;
        state.paymentLinkData = {};
      })
      .addCase(fetchPaymentLink.fulfilled, (state, action) => {
        state.isPaymentLoading = false;
        state.paymentLinkData = action.payload;
      })
      .addCase(fetchPaymentLink.rejected, (state, action) => {
        state.isPaymentLoading = false;
        state.paymentLinkData = {};
      });
  }
});
export const { clearLocalStorageOnLogout, setPaymentNull } =
  selfPacedSlice.actions;
export default selfPacedSlice.reducer;
